module.exports = __webpack_public_path__ + "static/media/11.40b48214.jpg";